 var InstallmentCalculator = window.InstallmentCalculator = function () {
     this.price = $('.finance_calculator').data('price');
     this.installmentCount = 60;
     this.advancePayment = 55;

 }

 InstallmentCalculator.prototype.init = function () {
     var self = this;

     if ($("#calc_slider_car_price").length) {
         // price slider
         var carprice = document.getElementById('calc_slider_car_price');

         noUiSlider.create(carprice, {
             start: this.price,
             connect: 'lower',
             step: $('.finance_calculator').data('price-step'),
             range: {
                 'min': 50000,
                 'max': 1000000
             },
             format: wNumb({
                 decimals: 0,
                 thousand: ' ',
             })
         });

         //set value from slider
         var carpriceField = document.getElementById('calc--car_price');
         carprice.noUiSlider.on('update', function (values, handle) {
             carpriceField.innerHTML = values[handle];
             self.price = parseInt(values[handle].replace(' ', '').replace(' ', ''));
             self.changePrice();
         });
     }


     if ($("#calc_slider_month").length) {
         // month slider
         var month_price = document.getElementById('calc_slider_month');

         noUiSlider.create(month_price, {
             connect: 'lower',
             start: [this.installmentCount],
             range: {
                 'min': [12, 12],
                 '13.5%': [24, 12],
                 '28%': [36, 12],
                 '42.5%': [48, 12],
                 '57%': [60, 12],
                 '71%': [72, 12],
                 '85.5%': [84, 12],
                 'max': [96]
             },
             format: wNumb({
                 decimals: 0,
                 thousand: ' ',
             })
         });

         $('.calc_value_month').on('click', function () {
             month_price.noUiSlider.set($(this).data('number'));
         });

         //set value from slider
         var monthPriceField = document.getElementById('calc--month');
         month_price.noUiSlider.on('update', function (values, handle) {
             monthPriceField.innerHTML = values[handle];
             self.installmentCount = parseInt(values[handle].replace(' ', '').replace(' ', ''));
             self.changePrice();

             // Add active class to the matching element
             var elements = document.querySelectorAll('.calc_value_month');
             elements.forEach(function (element) {
                 if (parseInt(element.getAttribute('data-number')) === self.installmentCount) {
                     element.classList.add('active');
                 } else {
                     element.classList.remove('active');
                 }
             });
         });
     }


     if ($("#calc_slider_akontace").length) {
         // akontace slider
         var akontaceSlider = document.getElementById('calc_slider_akontace');

         noUiSlider.create(akontaceSlider, {
             connect: 'lower',
             start: [this.advancePayment],
             range: {
                 'min': [0, 10],
                 '13.5%': [10, 5],
                 '27.5%': [15, 10],
                 '41%': [25, 10],
                 '55.5%': [35, 10],
                 '69.5%': [45, 10],
                 '83.5%': [55, 25],
                 'max': [70]
             },
             format: wNumb({
                 decimals: 0,
                 thousand: ' ',
             })
         });

         $('.calc_value_akontace').on('click', function () {
             akontaceSlider.noUiSlider.set($(this).data('number'));
         });

         //set value from slider
         // var akontacePriceField = document.getElementById('calc--car_akontace');
         akontaceSlider.noUiSlider.on('update', function (values, handle) {
             // akontacePriceField.innerHTML = values[handle];
             self.advancePayment = parseInt(values[handle].replace(' ', '').replace(' ', ''));
             self.changePrice();

             // Add active class to the matching element
             var elements = document.querySelectorAll('.calc_value_akontace');
             elements.forEach(function (element) {
                 if (parseInt(element.getAttribute('data-number')) === self.advancePayment) {
                     element.classList.add('active');
                 } else {
                     element.classList.remove('active');
                 }
             });
         });
     }
 }

 InstallmentCalculator.prototype.changePrice = function () {
     var price = Math.round((this.price * (1 - this.advancePayment / 100) / this.installmentCount * this.getCoefficient()));
     $('#calc--month_price').html(this.formatCena(price));
 }

 InstallmentCalculator.prototype.formatCena = function (cena) {
     var re = '\\d(?=(\\d{' + 3 + '})+$)';
     return cena.toFixed(0).replace(new RegExp(re, 'g'), '$& ') + ' Kč';
 };

 InstallmentCalculator.prototype.getCoefficient = function () {
     var coefficientsByPrice = {
         400000: {
             12: 1.02,
             24: 1.04,
             36: 1.05,
             48: 1.05,
             60: 1.08,
             72: 1.09,
             84: 1.11,
             96: 1.12,
             108: 1.12, // need to be checked 
             120: 1.12, // need to be checked
         },
         0: {
             12: 1,
             24: 1.022,
             36: 1.005,
             48: 1.01,
             60: 1.01,
             72: 1.01,
             84: 1.01,
             96: 1.01,
             108: 1.01, // need to be checked
             120: 1.01, // need to be checked
         }
     };

     var coefficients = coefficientsByPrice[0];
     if (this.price >= 400000) {
         coefficients = coefficientsByPrice[400000];
     }

     return coefficients[this.installmentCount];
 };